import { Employee } from '@components/employee/Employee'
import { selectSelectedCampaignEmployee } from '@store/CampaignEmployeeReducer'
import { SBAsyncSelect } from '@supplement-bacon/react-async-select'
import { SBRMFormActionProps } from '@supplement-bacon/sbrm-react'
import { Entity } from '@utils/Entities'
import { useAppSelector } from '@utils/hooks'
import { requiredRule, selectedIdIsNotHimself } from '@utils/rules'
import { Form, Input } from 'antd'
import { useEffect } from 'react'

const Update = ({ form, formProps }: SBRMFormActionProps) => {
  const item = useAppSelector(selectSelectedCampaignEmployee())

  useEffect(() => {
    form.setFieldsValue(item)
  }, [item])

  if (!item) {
    return <></>
  }

  return (
    <Form {...formProps} form={form} layout="vertical">
      <Form.Item
        name="id"
        required
        rules={[requiredRule()]}
        style={{ display: 'none' }}
      >
        <Input type="hidden" />
      </Form.Item>
      <Form.Item label="Employé">
        <Employee.Avatar id={item.employee} />
      </Form.Item>
      <Form.Item
        name="manager"
        label={'Manager'}
        rules={[
          selectedIdIsNotHimself(item.employee),
          ...(item.manager ? [requiredRule()] : []),
        ]}
      >
        <SBAsyncSelect allowClear entity={Entity.employee} />
      </Form.Item>
    </Form>
  )
}

export default Update
